/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const NewItemIcon = ({ width = 24, height = 24, hidden = false, title = 'New Item' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M6 6h22v22H6Zm-.8-2A1.19 1.19 0 0 0 4 5.2V29a1 1 0 0 0 1 1h23.8a1.19 1.19 0 0 0 1.2-1.2V5.2A1.189 1.189 0 0 0 28.8 4Z"
    />
    <path
      d="M16.5 10a.5.5 0 0 0-.5.5V16h-5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H16v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V18h5.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H18v-5.5a.5.5 0 0 0-.5-.5Z"
    />
  </svg>`;
};
